import { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { MAX_NUM_OF_QUESTION_OPTIONS } from 'cat-shared/utils'
import { AppFormSlider } from 'client/ui-building-blocks'

type Props = {
  step: number
  min: number
  max: number
}

const NumOfOptionsSlider = ({ step, min, max }: Props) => {
  const { t } = useTranslation()

  const { control, watch, resetField } = useFormContext()

  useEffect(() => {
    const subscription = watch(({ numOfOptions }, { name }) => {
      if (name === 'numOfOptions') {
        for (let n = numOfOptions + 1; n <= MAX_NUM_OF_QUESTION_OPTIONS; n++) {
          resetField(`options.${n}` as never)
        }
        resetField('correctOptions')
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  return (
    <Controller
      control={control}
      name="numOfOptions"
      render={({ field: { value, onChange } }) => {
        return (
          <AppFormSlider
            value={value}
            onChange={onChange}
            label={`${t('createQuestionPage.fields.numOfOptions')} (${value})`}
            min={min}
            max={max}
            step={step}
          />
        )
      }}
    />
  )
}

export default NumOfOptionsSlider
